<template>
  <div class="home">
    <div class="home__left-side">
      <div class="home__left-side__title">迅投云回测平台</div>
      <div class="home__left-side__body">
        <div v-for="(cluster,index) in clusterList" :key="index">
          <div
            class="home__left-side__body__cluster"
            :class="{active: whichClusterShow === cluster.name}"
            v-on:click="handleClickCluster(cluster)"
          >
            <div class="home__left-side__body__cluster__name">{{cluster.name}}</div>
            <button
              class="home__left-side__body__cluster__close-btn"
              @click.stop="handleClickCloseCluster(cluster.name)"
            >关闭</button>
          </div>
          <collapse-transition v-if="cluster.strategyList.length">
            <div v-show="whichClusterShow === cluster.name">
              <div
                v-for="(strategy,index) in cluster.strategyList"
                :key="index"
                v-on:click="handleClickStrategyItem(strategy)"
              >
                <StrategyItem :data="strategy" :selected="strategy.id === currentId" />
                <ListSplitLine
                  v-if="index === cluster.strategyList.length"
                  :lineStyle="{margin: '0 1.13rem'}"
                />
              </div>
            </div>
          </collapse-transition>
          <ListSplitLine :lineStyle="{margin: '0 1rem'}" />
        </div>
      </div>
      <div class="home__left-side__foot">
        <div class="add-backtest"></div>
      </div>
    </div>
    <div class="home__right-container">
      <div class="home__right-container__title">
        <div class="home__right-container__title__personal">
          <Personal :data="personal" />
        </div>
        <div class="home__right-container__title__total">
          <Total :data="total" />
        </div>
      </div>
      <div class="home__right-container__banner">
        <div class="home__right-container__banner__menu">
          <span
            class="home__right-container__banner__menu__item"
            :class="{active: showTab === 'status'}"
            @click="setShowTab('status')"
          >状态</span>
          <span
            class="home__right-container__banner__menu__item"
            :class="{active: showTab === 'cost'}"
            @click="setShowTab('cost')"
          >费用</span>
          <span
            class="home__right-container__banner__menu__item"
            :class="{active: showTab === 'instance'}"
            @click="setShowTab('instance')"
          >实例</span>
          <span
            class="home__right-container__banner__menu__item"
            :class="{active: showTab === 'start'}"
            @click="setShowTab('start')"
          >启动</span>
        </div>
        <div class="home__right-container__banner__status" v-show="showTab === 'status'">
          <div class="home__right-container__banner__item">
            <StatusCard :data="status.cpu" />
          </div>
          <div class="home__right-container__banner__item">
            <StatusCard :data="status.ram" />
          </div>
          <div class="home__right-container__banner__item">
            <StatusCard :data="status.disk" />
          </div>
          <div class="home__right-container__banner__item">
            <StatusCard :data="status.internet" />
          </div>
        </div>
        <div class="home__right-container__banner__cost-table" v-show="showTab === 'cost'">
          <CostTable :data="clustersCost" />
        </div>
        <div class="home__right-container__banner__start-cluster" v-show="showTab === 'start'">
          <StartCluster />
        </div>
        <div class="home__right-container__banner__instance-table" v-show="showTab === 'instance'">
          <InstanceTable :data="instanceStatus" />
        </div>
      </div>
      <div class="home__right-container__body" v-show="currentId !== -1">
        <div class="home__right-container__body__table-title">
          <div class="home__right-container__body__table-title__name">>> {{currentStrategy.name}}</div>
          <div
            class="home__right-container__body__table-title__progress-text"
          >{{currentStrategyProgress}}%</div>
          <div class="home__right-container__body__table-title__progress">
            <ProgressLine :value="currentStrategyProgress" />
          </div>
          <div
            class="home__right-container__body__table-title__status"
            :class="statusClass"
          >{{`${currentStrategy.status}，共${currentStrategy.items}项`}}</div>
        </div>

        <div class="home__right-container__body__table-sub-title">
          <img class="task-img" :src="task_img" alt="task图标" />
          <div>{{`已拆分为${currentStrategy.taskList.length}个子任务`}}</div>
          <img class="time-img" :src="time_img" alt="时间图标" />
          <div class="task-time">{{`已运行${currentStrategy.time}`}}</div>
          <div>{{`，${currentStrategy.create_time} -- ${currentStrategy.end_time === '' ? '任务没有结束暂无法显示': currentStrategy.end_time}`}}</div>
        </div>

        <div class="home__right-container__body__table-head">
          <table>
            <thead>
              <tr>
                <td></td>
                <td>任务列表</td>
                <td>运行状态</td>
                <td>运行时间</td>
                <td>开始时间</td>
                <td>结束时间</td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="home__right-container__body__table-body">
          <table>
            <tbody>
              <tr v-for="(task,index) in currentStrategy.taskList" :key="index">
                <td>{{index + 1}}</td>
                <td>{{task.name}}</td>
                <td>
                  <div class="inner">
                    <div class="flash-img">
                      <img :src="flash_img" alt="闪电" />
                    </div>
                    <div class="percent">{{Number((task.progress/task.items*100).toFixed(0))}}%</div>
                    <div class="progress">
                      <ProgressLine :value="Number((task.progress/task.items*100).toFixed(0))" />
                    </div>
                  </div>
                </td>
                <td>{{task.time}}</td>
                <td>{{task.create_time}}</td>
                <td>{{task.end_time === '' ? '--' : task.end_time}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressLine from "@/components/common/ProgressLine";
import CollapseTransition from "@/components/common/CollapseTransition";
import StrategyItem from "@/components/home/StrategyItem";
import ListSplitLine from "@/components/home/ListSplitLine";
import Personal from "@/components/home/Personal";
import Total from "@/components/home/Total";
import CostTable from "@/components/home/CostTable";
import StartCluster from "@/components/home/StartCluster";
import InstanceTable from "@/components/home/InstanceTable";
import StatusCard from "@/components/home/StatusCard";
import flash_img from "@/assets/images/flash.png";
import time_img from "@/assets/images/time.png";
import task_img from "@/assets/images/task.png";

export default {
  name: "home",
  data() {
    return {
      showTab: "status",
      currentStrategy: {
        id: -1,
        progress: 0,
        name: "",
        items: "",
        type: "",
        status: "",
        time: "",
        stockCount: 1000,
        create_time: "",
        end_time: "",
        taskList: []
      },
      whichClusterShow: "",
      clustersCost: [],
      clusterList: [],
      strategyList: [],
      instanceStatus: [],
      personal: {
        username: "投资经理Admin",
        expireDate: "2020-12-31",
        clusters: 0
      },
      total: {
        name: "XTCloudServices001890",
        status: "等待中",
        instanceSize: 0,
        time: "5天 23:45:23",
        logList: [
          // { level: "error", content: "用户名和密码错误" },
          // { level: "info", content: "请求成功" },
          // { level: "error", content: "请求数据失败" }
        ]
      },
      status: {
        cpu: {
          progress: 0,
          name: "CPU使用率",
          text: "全力运转中",
          colorStart: "#FF8900",
          colorStop: "#FF5400",
          color: "#FF5600",
          circleUnique: "cpu",
          history: [[]],
          progressType: "line"
        },
        ram: {
          progress: 0,
          name: "内存使用率",
          text: "共占用内存-G",
          colorStart: "#F7CD46",
          colorStop: "#EFAF47",
          color: "#EFAF47",
          circleUnique: "ram",
          history: [[]],
          progressType: "line"
        },
        disk: {
          progress: 0,
          name: "磁盘使用率",
          text: "剩余内存",
          colorStart: "#007CF7",
          colorStop: "#4E71E6",
          color: "#4E71E6",
          circleUnique: "disk",
          history: [[]],
          progressType: "line"
        },
        internet: {
          progress: 35,
          up: 0,
          down: 0,
          name: "网络I/O",
          text: "高速",
          circleText: "",
          colorStart: "#007CF7",
          colorStop: "#4E71E6",
          color: "#01B377",
          circleUnique: "internet",
          history: [[]],
          history_up: [],
          history_down: [],
          progressType: "wave"
        }
      },
      timmer: null,
      strategyTimmer: null,
      flash_img,
      time_img,
      task_img
    };
  },
  computed: {
    currentId: function() {
      return this.currentStrategy.id;
    },
    statusClass: function() {
      let name = "";
      switch (this.currentStrategy.status) {
        case "等待中":
          name = "wait";
          break;
        case "回测中":
          name = "progress";
          break;
        case "已完成":
          name = "finish";
          break;
      }
      return name;
    },
    currentStrategyProgress: function() {
      return (
        Number(
          (
            (this.currentStrategy.progress / this.currentStrategy.items) *
            100
          ).toFixed(0)
        ) || 0
      );
    }
  },
  methods: {
    toggleModalShow(isShow) {
      this.isShowModal = isShow;
    },
    setShowTab(name) {
      this.showTab = name;
    },
    handleClickCluster(cluster) {
      if (this.whichClusterShow === cluster.name) {
        this.whichClusterShow = "";
        this.currentStrategy.id = -1;
      } else {
        this.whichClusterShow = cluster.name;
      }
    },
    handleClickStrategyItem(strategy) {
      // 拷贝对象，防止handleClickCluster中修改currentStrategy.id 的连带效应
      this.currentStrategy = Object.assign({}, strategy);
    },
    handleClickCloseCluster(name) {
      this.$layer.confirm(`确定要关闭名称为：${name}的集群吗？`, layerId => {
        this.$layer.close(layerId);
        this.$router.push({
          query: {
            apply_data: "closeCluster",
            name,
            t: +new Date()
          }
        });
      });
    },
    setClustersCost(data) {
      this.clustersCost = data;
    },
    // 回测列表数据
    setStrategyListData(data) {
      // 集群列表
      this.clusterList = data;
      // total数据
      this.total.status = "回测中";
      this.total.instanceSize = this.clusterList.reduce(
        (sum, cur) => sum + cur.instanceSize,
        0
      );
      // 用户模块的显示
      this.personal.clusters = data.length;
      // 如果没有集群数据的信息显示
      if (data.length === 0) {
        this.currentStrategy.id = -1;
        this.total.status = "等待中";
      }
    },
    // 设置日志数据
    setLog(data) {
      let _dataArray = [].concat(this.total.logList);
      data.time = new Date().Format("yyyy-MM-dd hh:mm");
      _dataArray.push(data);
      if (_dataArray.length > 3) {
        _dataArray.shift();
      }
      this.total.logList = _dataArray;
    },
    // 实例状态-表格
    setInstanceStatus(data) {
      this.instanceStatus = data;
    },
    // 资源使用情况
    setResourceData(data) {
      // let data = JSON.parse(dataString);

      let { CPU, RAM, DISK, INTERNET } = data;
      // cpu
      this.status.cpu.progress = CPU.val;
      let cpuHistory = this.status.cpu.history[0]
        .slice(0, 50)
        .concat([CPU.val]);
      if (cpuHistory.length > 50) cpuHistory.shift();
      this.status.cpu.history.splice(0, 1, cpuHistory);
      // ram

      this.status.ram.progress =
        RAM.total === 0 ? 0 : (RAM.use / RAM.total) * 100;
      this.status.ram.text = `共占用内存${RAM.use.toFixed(2)}G`;
      let ramHistory = this.status.ram.history[0]
        .slice(0, 50)
        .concat([RAM.use]);
      if (ramHistory.length > 50) ramHistory.shift();
      this.status.ram.history.splice(0, 1, ramHistory);
      // disk
      this.status.disk.progress =
        DISK.total === 0 ? 0 : (DISK.use / DISK.total) * 100;
      this.status.disk.text = `剩余内存${
        DISK.total === 0 ? "-" : (DISK.total - DISK.use).toFixed(2)
      }G`;
      let diskHistory = this.status.disk.history[0]
        .slice(0, 50)
        .concat([DISK.use]);
      if (diskHistory.length > 50) diskHistory.shift();
      this.status.disk.history.splice(0, 1, diskHistory);
      // internet
      this.status.internet.up = Number(INTERNET.up.toFixed(2));
      this.status.internet.down = Number(INTERNET.down.toFixed(2));
      this.status.internet.circleText = `${INTERNET.down.toFixed(1)}k`;
      if (INTERNET.down === 0 && INTERNET.up === 0) {
        this.status.internet.progress = 0;
      } else {
        this.status.internet.progress =
          (INTERNET.down / (INTERNET.down + INTERNET.up)) * 100;
      }

      let upHistory = this.status.internet.history_up
        .slice(0, 50)
        .concat([INTERNET.up]);
      let downHistory = this.status.internet.history_down
        .slice(0, 50)
        .concat([INTERNET.down]);
      if (upHistory.length > 50) upHistory.shift();
      if (downHistory.length > 50) downHistory.shift();
      this.status.internet.history_up = upHistory;
      this.status.internet.history_down = downHistory;
      this.status.internet.history = [
        this.status.internet.history_up,
        this.status.internet.history_down.map(val => -val)
      ];
    }
  },
  mounted() {
    window.setStrategyListData = this.setStrategyListData;
    window.setResourceData = this.setResourceData;
    window.setClustersCost = this.setClustersCost;
    window.setLog = this.setLog;
    window.setInstanceStatus = this.setInstanceStatus;

    // window.setInstanceStatus([
    //   {
    //     name: "test1",
    //     instanceID: "i-002f7986836fc5e5d",
    //     cpu: 38.9,
    //     ram: {
    //       use: 97.9,
    //       total: 128
    //     },
    //     disk: {
    //       use: 23.6,
    //       total: 40
    //     },
    //     qmt_status: "运行中"
    //   },
    //   {
    //     name: "test1",
    //     instanceID: "i-0087f18f0a303db92",
    //     cpu: 38.9,
    //     ram: {
    //       use: 97.9,
    //       total: 128
    //     },
    //     disk: {
    //       use: 505,
    //       total: 1000
    //     },
    //     qmt_status: "等待任务"
    //   }
    // ]);

    // window.setStrategyListData([
    //   {
    //     name: "集群1",
    //     instanceSize: 2,
    //     status: "运行中",
    //     time: "共运行3.6个小时",
    //     create_time: "2020-01-10 02:29:27",
    //     end_time: "2020-01-15 14:59:44",
    //     strategyList: [
    //       {
    //         create_time: "",
    //         end_time: "",
    //         id: "0CJ1SYH500RX_003330015_11583720169",
    //         items: 100,
    //         name: "0CJ1SYH500RX_003330015_11583720169",
    //         progress: 15,
    //         status: "回测中",
    //         stockCount: 0,
    //         time: "",
    //         type: "VBA",
    //         taskList: [
    //           {
    //             id: 1,
    //             name: "任务1",
    //             group: "多因子策略模型",
    //             progress: 100,
    //             items: 1000,
    //             time: "159:01:44",
    //             create_time: "2020-01-10 02:37:01",
    //             end_time: "2020-01-15 17:17:33"
    //           },
    //           {
    //             id: 2,
    //             name: "任务2",
    //             group: "多因子策略模型",
    //             progress: 50,
    //             items: 1000,
    //             time: "159:01:19",
    //             create_time: "2020-01-10 02:37:26",
    //             end_time: "2020-01-15 17:16:43"
    //           }
    //         ]
    //       },
    //       {
    //         create_time: "",
    //         end_time: "",
    //         id: "0CJ1SYH500RX_00030014_1152821",
    //         items: 120,
    //         name: "0CJ1SYH500RX_00030014_1152821",
    //         progress: 0,
    //         status: "回测中",
    //         stockCount: 0,
    //         time: "",
    //         type: "VBA",
    //         taskList: [
    //           {
    //             id: 3,
    //             name: "任务1",
    //             group: "多因子策略模型",
    //             progress: 300,
    //             items: 1000,
    //             time: "159:01:44",
    //             create_time: "2020-01-10 02:37:01",
    //             end_time: "2020-01-15 17:17:33"
    //           },
    //           {
    //             id: 4,
    //             name: "任务2",
    //             group: "多因子策略模型",
    //             progress: 40,
    //             items: 1000,
    //             time: "159:01:19",
    //             create_time: "2020-01-10 02:37:26",
    //             end_time: "2020-01-15 17:16:43"
    //           }
    //         ]
    //       }
    //     ]
    //   },
    //   {
    //     name: "0CJ1SYH500RX_00030015_11583720169",
    //     instanceSize: 3,
    //     status: "待启动",
    //     time: "共运行7.6个小时",
    //     create_time: "2020-03-24 9:30",
    //     end_time: "2020-03-24 19:00",
    //     strategyList: [
    //       {
    //         create_time: "",
    //         end_time: "",
    //         id: "0CJ1SYH500RX_00030015_11583720169",
    //         items: 60,
    //         name: "0CJ1SYH500RX_00030015_11583720169",
    //         progress: 0,
    //         status: "回测中",
    //         stockCount: 0,
    //         time: "",
    //         type: "VBA",
    //         taskList: []
    //       },
    //       {
    //         create_time: "",
    //         end_time: "",
    //         id: "0CJ1SYH500RX_00030014_11583736821",
    //         items: 90,
    //         name: "0CJ1SYH500RX_00030014_11583736821",
    //         progress: 0,
    //         status: "回测中",
    //         stockCount: 0,
    //         time: "",
    //         type: "VBA",
    //         taskList: []
    //       }
    //     ]
    //   }
    // ]);
    // window.setResourceData({
    //   CPU: {
    //     val: 0
    //   },
    //   DISK: {
    //     total: 0,
    //     use: 0
    //   },
    //   INTERNET: {
    //     down: 0,
    //     up: 0
    //   },
    //   RAM: {
    //     total: 0,
    //     use: 0
    //   }
    // });

    // setInterval(() => {
    //   this.clusterList[0].strategyList[0].progress = 1 + Math.random() * 10;
    //   this.status.ram.progress = 20 + Math.random() * 10;
    //   window.setLog({
    //     level: "error",
    //     content: "示例错误信息" + Math.random() * 10
    //   });
    //   window.setResourceData({
    //     CPU: {
    //       val: 13 + Math.random() * 5
    //     },
    //     DISK: {
    //       total: 1000,
    //       use: 360 + Math.random() * 30
    //     },
    //     INTERNET: {
    //       down: 27.1083984375 + Math.random() * 5,
    //       up: 113.2392578125 + Math.random() * 5
    //     },
    //     RAM: {
    //       total: 8192,
    //       use: 4096 + Math.random() * 5
    //     }
    //   });
    // }, 2000);
  },
  components: {
    CollapseTransition,
    ProgressLine,
    StrategyItem,
    ListSplitLine,
    Personal,
    Total,
    CostTable,
    InstanceTable,
    StartCluster,
    StatusCard
  }
};
</script>

<style lang="less" scoped>
.home {
  max-width: 1440px;
  min-width: 1024px;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  color: @white;
  box-sizing: border-box;

  &__left-side {
    width: 20rem;
    display: flex;
    flex-direction: column;

    &__title {
      height: 3rem;
      font-size: 1rem;
      font-weight: bold;
      line-height: 3rem;
      text-align: center;
      background-color: #333643;
    }

    &__body {
      flex: 1;
      overflow-y: auto;
      background-color: #262934;

      &__cluster {
        width: 20rem;
        cursor: pointer;
        padding: 0.5rem 1rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        transition-duration: 0.4s;
        position: relative;

        &__name {
          margin-right: 1rem;
          width: 13rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &.active {
          background-color: rgba(51, 54, 67, 0.6);

          &::after {
            content: "";
            display: block;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 0.25rem;
            height: 50%;
            background: #4e72e7;
            border-radius: 0.13rem;
          }
        }
        &:hover {
          background-color: rgba(51, 54, 67, 0.6);
        }
        &__close-btn {
          cursor: pointer;
          border: none;
          border-radius: 0.2rem;
          padding: 0.2rem 0;
          width: 3.5rem;
          outline: none;
          display: inline-block;
          text-align: center;
          text-decoration: none;
          color: white;
          font-size: 0.86rem;
          background-color: #ff7813;
          transition-duration: 0.4s;

          &:hover {
            background-color: rgba(255, 120, 19, 0.7);
          }
        }
      }
    }

    &__foot {
      height: 5.38rem;
      display: flex;
      align-items: center;
      background-color: #262934;

      .add-backtest {
        margin: 0 auto;
        width: 14.25rem;
        height: 2.88rem;
        border-radius: 0.25rem;
        background-image: url("@{image-url}/add-backtest.png");
        background-size: 100% 100%;
        // font-size: 0.88rem;
        // line-height: 2.88rem;
        // text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.18);
        // text-align: center;
        // text-indent: 2rem;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  &__right-container {
    flex: 1;
    flex-direction: column;
    padding: 1.75rem 1.88rem;
    border-right: 0.13rem #262934 solid;
    box-sizing: border-box;

    &__title {
      display: flex;
      height: 12.5rem;
      justify-content: space-between;

      &__personal {
        width: 21.25rem;
        min-width: 30%;
      }
      &__total {
        width: 43.13rem;
        margin-left: 1.88rem;
      }
    }

    &__banner {
      display: flex;
      flex-direction: column;
      height: 12rem;
      margin-top: 1.88rem;

      &__menu {
        width: 100%;
        height: 2rem;
        font-size: 0.86rem;

        &__item {
          margin-right: 0.5rem;
          cursor: pointer;
          transition: all linear 0.3s;
          &.active {
            color: rgb(239, 175, 71);
          }
        }
      }

      &__cost-table,
      &__start-cluster {
        width: 100%;
        height: 10rem;
      }
      &__start-cluster {
        display: flex;
        flex-flow: column;
        justify-content: center;
      }

      &__status {
        display: flex;
        width: 100%;
        height: 10rem;
        justify-content: space-between;
      }
    }

    &__body {
      flex: 1;
      &__table-title {
        display: flex;
        height: 1.25rem;
        font-size: 0.88rem;
        margin-top: 1.88rem;

        &__name {
          width: fit-content;
          margin-right: 1.25rem;
        }

        &__progress-text {
          width: fit-content;
          color: #4c70e3;
          margin-right: 0.63rem;
        }

        &__progress {
          width: 13.75rem;
          display: flex;
          align-items: center;
        }

        &__status {
          flex: 1;
          text-align: right;

          &.progress {
            color: #01b377;
          }
          &.finish {
            color: #4e71e6;
          }
          &.wait {
            color: #9eabbe;
          }
        }
      }

      &__table-sub-title {
        display: flex;
        align-items: center;
        font-size: 0.88rem;
        margin-top: 1.3rem;
        color: #cad0d5;

        & .task-img {
          margin-right: 0.23rem;
          width: 1.125rem;
          height: 1.28rem;
        }

        & .time-img {
          width: 1.13rem;
          height: 1.13rem;
          margin-left: 1.25rem;
          margin-right: 0.23rem;
        }

        & .task-time {
          color: #e02020;
        }
      }

      &__table-head {
        margin-top: 0.75rem;
        & > table {
          width: 100%;
          background-color: #1c2130;
          font-size: 0.75rem;
          color: #9eabbe;
        }
        & > table > thead > tr {
          height: 2.5rem;
          text-align: center;
          // display: flex;
          & td:nth-child(1) {
            width: 2.5rem;
          }
          & td:nth-child(2) {
            width: 7.19rem;
          }
          & td:nth-child(3) {
            width: 13.81rem;
          }
          & td:nth-child(4) {
            width: 10.69rem;
          }
          & td:nth-child(5) {
            width: 11.25rem;
          }
          // & td:nth-child(6) {
          // flex: 1;
          // }
        }
      }

      &__table-body {
        height: calc(100vh - 43rem);
        overflow-y: auto;

        & > table {
          width: 100%;
          font-size: 0.75rem;
          color: #9eabbe;
          border-collapse: collapse;

          & > tbody tr,
          & > tbody td {
            border: 1px solid #191b23;
          }
        }

        & > table > tbody > tr {
          height: 2.5rem;
          text-align: center;
          // display: flex;
          & td:nth-child(1) {
            width: 2.5rem;
          }
          & td:nth-child(2) {
            width: 7.19rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          & td:nth-child(3) {
            width: 13.81rem;

            & > div.inner {
              display: flex;
              align-items: center;
              & div.flash-img {
                width: 0.63rem;
                margin-right: 0.5rem;

                & > img {
                  width: 0.63rem;
                  height: 0.63rem;
                }
              }
              & div.percent {
                width: 15%;
                margin-right: 0.63rem;
              }
              & div.progress {
                flex: 1;
                width: 85%;
                height: 100%;
              }
            }
          }
          & td:nth-child(4) {
            width: 10.69rem;
          }
          & td:nth-child(5) {
            width: 11.25rem;
          }
          // & td:nth-child(6) {
          // flex: 1;
          // }
        }
      }
    }
  }
}
</style>
